import { IRoute } from "shared/interface/types";
import { AutoShelfPlanB2CRoutes } from "./shelfPlanRoute/B2CRoute";
import { AutoShelfPlanB2B2CRoutes } from "./shelfPlanRoute/B2B2CRoute";
import { autoOrderRoutes } from "./autoOrderRoute";
import { AutoShelfPlanB2BRoutes } from "./shelfPlanRoute/B2BRoute";

export const AutoRoutes: IRoute[] = [...AutoShelfPlanB2CRoutes, ...AutoShelfPlanB2BRoutes, ...AutoShelfPlanB2B2CRoutes, ...autoOrderRoutes];
